// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
   scanned_image_cloudfront_url: 'https://d1ixnw3jq0l2nq.cloudfront.net',
   microservices_url: 'https://api.bouncepages.savvasrealizedev.com/controller',
   fetchmarker_url: 'https://api.bouncepages.savvasrealizedev.com/pwa/fetchmarkerdetails',
   /*'https://savvasdevelop.tk/controller' */
   marker_url: 'https://d2xzkxbfsakk2c.cloudfront.net/public/markers',
   widget_url: 'https://d2xzkxbfsakk2c.cloudfront.net/public/widgets',
   google_analytics_id: 'UA-40456310-9'
 };

 /*
  * For easier debugging in development mode, you can import the following file
  * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
  *
  * This import should be commented out in production mode because it will have a negative impact
  * on performance if an error is thrown.
  */
 // import 'zone.js/dist/zone-error';  // Included with Angular CLI.
